import MinimalLayout from "../layout/MinimalLayout";
import AdminLogin from "../views/authentication/AdminLogin";
import ForgotPassword from "../views/authentication/ForgotPassword";
import ResetPassword from "../views/authentication/ResetPassword";
import ForgotHome from "../views/authentication/ForgotHome";
import PrivacyPolicy from "../views/Legal/PrivacyPolicy";
import TermsAndConditions from "../views/Legal/TermsAndConditions";
import DeleteAccountGuideline from "../views/DeleteAccountGuideline";
import HelpSupport from "../views/Legal/HelpSupport";
import Consent from "../views/Legal/Pages/Consent";

const PublicRoutes = [
  {
    path: "/login",
    element: <MinimalLayout><AdminLogin /></MinimalLayout>
  },
  {
    path: "/forgot-password",
    element: <MinimalLayout><ForgotPassword /></MinimalLayout>
  },
  {
    path: "/reset-password/:token",
    element: <MinimalLayout><ResetPassword /></MinimalLayout>
  },
  {
    path: "/forgot-home",
    element: <MinimalLayout><ForgotHome /></MinimalLayout>
  },
  {
    path: "/privacy-policy",
    element: <MinimalLayout><PrivacyPolicy /></MinimalLayout>
  },
  {
    path: "/terms-conditions",
    element: <MinimalLayout><TermsAndConditions /></MinimalLayout>
  },
  {
    path: "/help-support",
    element: <MinimalLayout><HelpSupport /></MinimalLayout>
  },
  {
    path: "/consent",
    element: <MinimalLayout><Consent /></MinimalLayout>
  },
  { path: "delete-account-guideline", element: <DeleteAccountGuideline /> },
];

export default PublicRoutes;
